module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [(!_vm.isLogin && !_vm.isNewPassword) ? _c('b-row', [(_vm.configLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.configLoading) ? _c('b-navbar', {
    staticClass: "col-md-3 col-lg-2 d-block sidebar",
    attrs: {
      "toggleable": "md"
    }
  }, [_c('a', {
    staticClass: "nav-logo"
  }, [_vm._v(_vm._s(_vm.configCompany.name))]), _vm._v(" "), _c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "flex-column"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'CustomerList'
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "client",
      "size": "24"
    }
  }), _vm._v("Klienci")], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'AgreementList'
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "agreement",
      "size": "24"
    }
  }), _vm._v("Umowy")], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'FactoredInvoiceList'
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "factoredInvoice",
      "size": "24"
    }
  }), _vm._v("Faktury")], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'DebtorList'
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "deptor",
      "size": "24"
    }
  }), _vm._v("Dłużnicy")], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'InvoiceList'
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "invoice",
      "size": "24"
    }
  }), _vm._v("Sprzedaż")], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ReportList'
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "report",
      "size": "24"
    }
  }), _vm._v("Raporty")], 1)], 1), _vm._v(" "), (_vm.checkPrivilege('ROLE_ADMIN')) ? _c('li', {
    staticClass: "nav-item nav-item-separated"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'UserList'
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "user",
      "size": "24"
    }
  }), _vm._v("Użytkownicy")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.checkPrivilege('ROLE_ADMIN')) ? _c('router-link', {
    staticClass: "nav-item nav-item--parent",
    attrs: {
      "tag": "li",
      "to": {
        name: 'settings'
      }
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('svg-icon', {
    attrs: {
      "name": "settings",
      "size": "24"
    }
  }), _vm._v("Ustawienia")], 1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'CurrencyTypeList'
      }
    }
  }, [_vm._v("Waluty")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'FileTypeList'
      }
    }
  }, [_vm._v("Pliki")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'TransferTypeList'
      }
    }
  }, [_vm._v("Przelewy")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'CompanyShow'
      }
    }
  }, [_vm._v("Firma")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'InvoicePaymentTypeList'
      }
    }
  }, [_vm._v("Płatności")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'InvoiceTaxTypeList'
      }
    }
  }, [_vm._v("Stawki VAT")])], 1)])]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.configLoading) ? _c('main', {
    staticClass: "col-md-9 col-lg-10 content",
    attrs: {
      "role": "main"
    }
  }, [_c('b-row', [_c('nav', {
    staticClass: "navbar-user col-sm-12"
  }, [_c('p', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Witaj, " + _vm._s(_vm.userFullName) + " "), _c('svg-icon', {
    attrs: {
      "name": "logout"
    }
  })], 1)])])]), _vm._v(" "), _c('b-row', [_c('router-view')], 1), _vm._v(" "), _c('footer', [_c('p', {
    staticClass: "text-right"
  }, [_vm._v("© " + _vm._s(_vm.currentYear) + " - Syndykat Katowice")])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('b-row', {
    staticClass: "login-row justify-content-center",
    attrs: {
      "align-v": "center"
    }
  }, [_c('login')], 1) : _vm._e(), _vm._v(" "), (_vm.isNewPassword) ? _c('b-row', {
    staticClass: "login-row justify-content-center",
    attrs: {
      "align-v": "center"
    }
  }, [_c('new-password')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 842
// module chunks = 0